import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const GlobalModal = ({ showDynamic, setShowDynamic, dynamicText, handleAquaSwapWallet }) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal className="detail error-msg-modal" show={showDynamic} centered>
                <Modal.Body>
                    <div className="innercontent">
                         <div className="upperimg">
                            <img
                                src="\assets\warning.svg"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="newtextstyle">WARNING</h2>
                        <h2 className="upperheading">{dynamicText}</h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleAquaSwapWallet()
                            }}
                        >
                            {t("Okay")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default GlobalModal
